import axios, { CancelToken } from 'axios';
import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 生成访问obs的临时url
export const getSignedurl = (data: any, cancelToken?: CancelToken) => {
  // 后端要求这个contentType字段要保证和 singedUrl 上传的 content-type 一致
  data.contentType = data.contentType || 'application/octet-stream';
  return request({
    url: `${BASE_URL.scmServer}/api/admin/common/file/getSignedUrl.ac`,
    method: 'post',
    data,
    cancelToken,
  });
};

// 根据 singnedUrl 保存文件
export const saveFileBySingedUrl = (
  signedUrl: any,
  data: any,
  cancelToken?: CancelToken
) => {
  return axios({
    url: `${signedUrl}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    data,
    cancelToken,
  });
};

// 保存文件
export const saveFileInfo = (data: any, cancelToken?: CancelToken) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/common/file/saveFileInfo.ac`,
    method: 'post',
    data,
    cancelToken,
  });
};
